import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { IndentIssueHeaderData, IndentIssueHeader } from '../../../interfaces/pharmacy/IndentIssueHeader';
import { IndentIssueApi } from '../api/IndentIssue.api';

@Injectable() 
export class IndentIssueService extends IndentIssueHeaderData{
 
  constructor(private api: IndentIssueApi) {
    super();
  } 
  
  getall(url: string): Observable<IndentIssueHeader[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<IndentIssueHeader>{
      return this.api.getby_id(url);
  }

  create(url: string, data:IndentIssueHeader): Observable<IndentIssueHeader[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:IndentIssueHeader): Observable<IndentIssueHeader> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
